import { isTestnet } from './contracts-config'

/**
 * DEX Router Addresses
 * Supports both testnet and mainnet modes
 */
export const DEX_ROUTERS: Record<string, { mainnet: string; testnet: string }> = {
    'pancakeswap-v2': {
        mainnet: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
        testnet: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1'
    },
    'pancakeswap-v3': {
        mainnet: '0x1b81D678ffb9C0263b24A97847620C99d213eB14',
        testnet: '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B'
    },
    'uniswap-v2': {
        mainnet: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
        testnet: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D' // Most testnets use standard V2 address
    },
    'sushiswap': {
        mainnet: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
        testnet: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506'
    },
    'quickswap': {
        mainnet: '0xa5E0829CaCEd8fFDD03942105944f12d197441E9',
        testnet: '0x8954aFA98594b874330739D6132c72ea74442aA7' // Polygon Mumbai/Amoy variant
    },
    'baseswap': {
        mainnet: '0x327dF1E6de5985753B213a1919869666Bc71eeE1',
        testnet: '0x327dF1E6de5985753B213a1919869666Bc71eeE1'
    }
}

/**
 * Get router address for a specific DEX based on current network mode
 */
export function getDexRouter(dexKey: string): string | null {
    const mode = isTestnet ? 'testnet' : 'mainnet'
    const config = DEX_ROUTERS[dexKey]
    if (!config) return null
    return config[mode] || null
}
